import { type CommonTemplateProps } from '#app/components/Modals/V2/GlobalModalSystem/types.js';
import { useAuth } from '#app/hooks/useAuth.js';
import { useIsMobile } from '#app/hooks/useIsMobile.js';
import { useNavigation } from '#app/hooks/useNavigation.js';
import { ModalTemplateWrapper } from '../ModalTemplateWrapper/ModalTemplateWrapper.js';
import { getRoute } from '@contra/routes';

type LogoutModalProps = CommonTemplateProps & {};

export const LogoutModal = ({ closeModal, isOpen }: LogoutModalProps) => {
  const isMobile = useIsMobile();
  const navigation = useNavigation();
  const { isLoggingOut, logout } = useAuth();
  const onLogout = async () => {
    logout({
      onCompleted: () => {
        closeModal();
        navigation.push(getRoute('/log-in'));
      },
      variables: {},
    });
  };

  return (
    <ModalTemplateWrapper
      ariaLabel="Are you sure you want to log out?"
      ctaOptions={{
        primaryCTA: {
          additionalProps: isMobile
            ? {
                marginTop: '16px',
              }
            : undefined,
          handleOnClick: onLogout,
          isLoading: isLoggingOut,
          label: 'Log Out',
        },
        secondaryCTA: {
          handleOnClick: closeModal,
          label: 'Cancel',
        },
      }}
      desktopModalSize="md"
      headerText="Are you sure you want to log out?"
      isOpen={isOpen}
      onClose={closeModal}
    />
  );
};
